import { urlReplace } from "helpers/url";
import Api from "./Api";

export default class PermissionService {
	constructor(api) {
		this.api = api || new Api();
	}

	async getAll(params) {
		return this.api.get('/secure/permissions', params);
	}

	async getById(id, params) {
		return this.api.get(urlReplace('/secure/permission/{id}', { id: id }), params);
	}

}